// extracted by mini-css-extract-plugin
export default {"errorContainer":"RouteAuthorize_errorContainer__6jAMU","errorTitle":"RouteAuthorize_errorTitle__BtgfE","errorMessageWrapper":"RouteAuthorize_errorMessageWrapper__h-1+T"};